module.exports = __webpack_public_path__ + "ae6879c2af0403739fbfaeed095255fe.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/flags/GB.svg
// module id = 519
// module chunks = 74